var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "420px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.reset,
      },
    },
    [
      _c(
        "el-form",
        {
          attrs: { "label-width": "90px" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _vm.requireOld
            ? _c(
                "el-form-item",
                { attrs: { label: "原密码" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "show-password": "",
                      autocomplete: "off",
                      placeholder: "请输入原密码",
                    },
                    model: {
                      value: _vm.form.oldPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "oldPassword", $$v)
                      },
                      expression: "form.oldPassword",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "新密码" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  "show-password": "",
                  autocomplete: "off",
                  placeholder: "请输入新密码",
                },
                model: {
                  value: _vm.form.newPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "newPassword", $$v)
                  },
                  expression: "form.newPassword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "确认密码" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  "show-password": "",
                  autocomplete: "off",
                  placeholder: "请再次输入新密码",
                },
                model: {
                  value: _vm.form.confirmPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "confirmPassword", $$v)
                  },
                  expression: "form.confirmPassword",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.submit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }